import { createAction } from '@reduxjs/toolkit'


export const setLatestBlock = createAction<{ latestBlock: number | null }>('blocks/setLatestBlock');

export const setPariListStory = createAction<{ pariListStory: any [] | null }>('blocks/setPariList');
